import { render, staticRenderFns } from "./Payment2.vue?vue&type=template&id=a485f5ea&scoped=true"
import script from "./Payment2.vue?vue&type=script&lang=js"
export * from "./Payment2.vue?vue&type=script&lang=js"
import style0 from "./Payment2.vue?vue&type=style&index=0&id=a485f5ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a485f5ea",
  null
  
)

export default component.exports